export enum MapIconsPins {
  MAP_ICON_PIN = 'ic cmx-icon-map-pin',
  MAP_ICON_PIN_ERROR = 'ic cmx-icon-pin-error',
}
